/* global angular */

var ngModule = angular.module('trends');

ngModule.directive('trendWiif', ['Api', 'AjaxList',
    function (Api, AjaxList) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                var hvtId = parseInt(attrs.hvtId, 10);
                var ajaxWiif = new AjaxList(Api.wiif);
                scope.hvtTitle = attrs.hvtTitle;
                scope.trendHvtWiifs = {};

                ajaxWiif.loadNext({hvt: hvtId}).then(function (result) {
                    if (result.length > 0) {
                        for (var i = 0; i < result.length; i++) {
                            scope.trendHvtWiifs[result[i].trend] = result[i].body;
                        }
                    }
                    else {
                        element.addClass('no-wiif');
                    }
                });
            }
        };
    }
]);
